import React from "react";
import Lista from "../../components/search-list";

export default ({ location, match }) => {
  let initialState = location.state || {};
  // if (match.params && match.params.tipo) initialState.tipo = match.params.tipo;
  // if (match.params && match.params.transacao)
  // initialState.transacao = match.params.transacao;
  return <Lista initialState={initialState} locationKey={location.key} />;
};
